import React from 'react';
import { looksLikeHtml, sanitizeRichTextHtml } from '../../utils/richText';
import './formsRichText.css';

const RichTextContent = ({ html, className = '', as: Tag = 'div' }) => {
  const content = html || '';
  if (!content) return null;

  if (!looksLikeHtml(content)) {
    return <Tag className={className}>{content}</Tag>;
  }

  return (
    <Tag
      className={`forms-rich-content${className ? ` ${className}` : ''}`}
      dangerouslySetInnerHTML={{ __html: sanitizeRichTextHtml(content) }}
    />
  );
};

export default RichTextContent;
